import React from "react";
import { LoadingOverlay, Flex } from "@mantine/core";
import { IconHourglass } from "@tabler/icons-react";
import "./LoadingOverLayCustom.css";
const LoadingOverlayCustom = ({ visible }: { visible: boolean }) => {
  return (
    <LoadingOverlay
      visible={visible}
      zIndex={1000}
      style={{ height: "100vh" }}
      overlayProps={{ radius: "sm", blur: 2 }}
      loaderProps={{
        children: (
          <Flex justify={"center"} align="center" direction="column">
            <IconHourglass
              stroke={1}
              className="icon-shake"
              style={{
                width: "50px",
                height: "37px",
              }}
              color="blue"
            />
            <span
              style={{
                fontSize: "16px",
                fontWeight: "400",
                marginTop: "5px",
              }}
            >
              Vui lòng đợi chút...
            </span>
          </Flex>
        ),
      }}
    />
  );
};

export default LoadingOverlayCustom;
